import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onAddinSubcommandsTrigger = action("onAddinSubcommandsTrigger", event => ({
    event,
    owaType: "addIn",
})) as OwaNovaActionUnion<"addIn">;
